import { Fragment } from "react";
import { Icon } from "@iconify/react";
import { CheckItem, Container, Eyebrow, IconTile } from "./primitives";

const POINTS = [
  "AI reads and structures clinical text automatically",
  "Uncertain or conflicting data is routed to human review",
  "Verified hospital records always override AI extractions",
  "Every decision is logged and auditable",
];

const PIPELINE = [
  { icon: "lucide:file-text",              title: "Raw Document",   sub: "PDF, HL7, FHIR, Scan"        },
  { icon: "lucide:cpu",                    title: "AI Extraction",  sub: "Clinical data structured"    },
  { icon: "lucide:eye",                    title: "Human Review",   sub: "Flagged items verified"      },
  { icon: "lucide:chart-no-axes-column",   title: "Your Dashboard", sub: "Accurate, organized, clear", verified: true },
];

export function VerificationSection() {
  return (
    <section className="bg-[#120240] bg-[radial-gradient(ellipse_70%_90%_at_75%_50%,#1E023F_0%,rgba(18,2,64,0)_70%)] py-20 lg:py-[100px]">
      <Container className="grid items-center gap-14 lg:grid-cols-[minmax(0,1fr)_559px] lg:gap-10">
        <div className="max-w-[570px]">
          <Eyebrow>Our trust differentiator</Eyebrow>
          <h2 className="!mt-4 text-[38px] font-extrabold leading-[1.06] tracking-[-0.04em] text-white md:text-[46px]">
            AI-Assisted,
            <br />
            <span className="text-[#F18095]">Human-Verified.</span>
          </h2>
          <p className="!mt-6 text-[17px] leading-[29px] text-white/65">
            Every AI-extracted record is flagged and reviewed before it's treated as fact. Your verified hospital
            data always comes first. AI fills the gaps, humans catch the errors.
          </p>
          <ul className="!mt-8 space-y-[19px] text-[16px] text-white/85">
            {POINTS.map(p => <CheckItem key={p} tone="solid">{p}</CheckItem>)}
          </ul>
        </div>

        <ol className="flex flex-col items-stretch">
          {PIPELINE.map((step, i) => (
            <Fragment key={step.title}>
              {i > 0 && <span aria-hidden="true" className="mx-auto h-9 w-px bg-white/15" />}
              <li className="flex h-[78px] items-center gap-4 rounded-xl bg-white px-5">
                <IconTile
                  icon={step.icon}
                  className="h-11 w-11 rounded-[10px] border border-[#E86C84] bg-[#F18095]"
                  iconClassName="h-5 w-5 text-white"
                />
                <span className="min-w-0 flex-1">
                  <span className="flex flex-wrap items-center gap-2">
                    <span className="text-[15px] font-bold text-[#120240]">{step.title}</span>
                    {step.verified && (
                      <span className="flex h-[18px] items-center gap-1 rounded-full bg-[#4FC97D] px-2 text-[11px] font-semibold text-white">
                        <Icon icon="lucide:check" className="h-2.5 w-2.5" strokeWidth={3} />
                        Verified
                      </span>
                    )}
                  </span>
                  <span className="mt-0.5 block text-[13px] text-[#9CA3AF]">{step.sub}</span>
                </span>
                <span className="text-[12px] font-bold text-[#120240]">{String(i + 1).padStart(2, "0")}</span>
              </li>
            </Fragment>
          ))}
        </ol>
      </Container>
    </section>
  );
}
